import styled from 'styled-components';

export const BlockContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 700px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const BlockItemContainer = styled.div`
  padding: 1.5rem;
  border: 1px solid #4b286d;
  border-radius: 1rem;
  position: relative;
  overflow: hidden;
`;

export const BlockItemHead = styled.div`
  display: grid;
  grid-template-columns: 2.5fr 1fr;
  align-items: center;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e3e3e3;
  padding-bottom: 1rem;
  justify-items: end;
`;

export const BlockTitle = styled.p`
  justify-self: start;
  font-size: 18px;
  font-weight: 600;
  color: #4b286d;
`;

export const BlockFormControl = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const FormControl = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
`;

export const FormControlLabel = styled.div`
  color: ${props => (props.isActive ? '#4b286d' : '#666')};
  font-weight: ${props => (props.isActive ? '500' : '400')};
`;

export const EditOverlay = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.94);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
`;

export const ErrorMessage = styled.p`
  color: #c12335;
`;
